import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { fetchLeadMetrics, type LeadMetrics } from "@/api/adminLeads";

const emptyMetrics: LeadMetrics = {
  summary: {
    total: 0, new_leads: 0, pending: 0, information: 0, success: 0,
    unassigned: 0, sms_sent: 0, sms_failed: 0, viewed: 0, today: 0,
    stale_pending: 0, duplicates: 0, avg_assignment_hours: 0,
  },
  stage: [], service: [], source: [], timeframe: [], postal: [], campaign: [], partner: [], monthly: [], daily: [], recent: [],
  comparison: { current: 0, previous: 0 },
  weekly_pulse: { current: 0, previous: 0 },
};

export function useLeadMetrics(range: string, services: string[] = []) {
  const normalizedServices = [...services].sort();
  const query = useQuery({
    queryKey: ["admin-lead-metrics", range, normalizedServices.join(",")],
    queryFn: () => fetchLeadMetrics(range, normalizedServices),
    staleTime: 45_000,
    placeholderData: keepPreviousData,
  });

  return {
    metrics: query.data ?? emptyMetrics,
    loading: query.isLoading,
    isFetching: query.isFetching,
    error: query.error instanceof Error ? query.error.message : null,
    refetch: query.refetch,
  };
}
